import { assert } from '@ember/debug';
import { typeOf } from '@ember/utils';
import { get } from '@ember/object';
export default function (item, property) {
  let itemType = typeOf(item);
  if (!item) {
    return '';
  } else if (itemType === 'number' || itemType === 'string') {
    return item;
    // @ts-ignore: TS incorrectly asserts that 'object' is not possible
  } else if (itemType === 'instance' || itemType === 'object') {
    return get(item, property);
  } else {
    assert('dropdown items must be a string, number, object, or Ember.Object', false);
  }
}